module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-latin-ext487.c11e12b.woff2";